"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomLogger_1 = __importDefault(require("./CustomLogger"));
class ErrorHandler {
    static handleError(error) {
        CustomLogger_1.default.logError(error);
    }
    static handleUnhandledRejection(event) {
        const error = event.reason instanceof Error
            ? event.reason
            : new Error(typeof event.reason === "string" ? event.reason : "Unknown reason");
        CustomLogger_1.default.logError(error);
    }
    static handleUnhandledError(event) {
        var _a;
        const errorDetails = {
            title: event.message,
            stack: (_a = event.error) === null || _a === void 0 ? void 0 : _a.stack,
        };
        CustomLogger_1.default.sendErrorToEndpoint(errorDetails);
    }
    static init(envKey, appVersion) {
        CustomLogger_1.default.init(envKey, appVersion); // Initialize the environment key and app version once
        if (typeof window !== "undefined") {
            // Browser environment
            window.addEventListener("unhandledrejection", (event) => ErrorHandler.handleUnhandledRejection(event));
            window.addEventListener("error", (event) => ErrorHandler.handleUnhandledError(event));
        }
        else if (typeof process !== "undefined") {
            // Node.js environment
            process.on("uncaughtException", (error) => {
                ErrorHandler.handleError(error);
            });
            process.on("unhandledRejection", (reason) => {
                const error = reason instanceof Error ? reason : new Error(String(reason));
                ErrorHandler.handleError(error);
            });
        }
    }
}
exports.default = ErrorHandler;
